module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loaded) ? _c('div', [_vm._v("Chargement ...")]) : _vm._e(), _vm._v(" "), (_vm.loaded && _vm.found) ? _c('img', {
    attrs: {
      "src": _vm.src
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loaded && !_vm.found) ? _c('NotFoundView') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a9ddc4f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Photo.vue
// module id = 2128
// module chunks = 2